import update from 'immutability-helper'
import { useCallback, useState, useEffect  } from 'react'
import { Card } from './CardNivel1.js'
const style = {
  width: '100%',
}
const Container = ({modulos, onAcordionModulo, onShowModal, onEliminarModulo}) => {
    
    const [cards, setCards] = useState(modulos);
    
    
    useEffect(() => {
        //Runs on every render
        if(modulos.update!=cards.update){
            setCards(modulos);
        }
    });

    
    const moveCard = useCallback((dragIndex, hoverIndex) => {
      setCards((prevCards) =>
        update(prevCards, {
          $splice: [
            [dragIndex, 1],
            [hoverIndex, 0, prevCards[dragIndex]],
          ],
        }),
      )
    }, [])
    
    
    const renderCard = useCallback((card, index, onAcordionModulo, onShowModal, onEliminarModulo) => {
        card.index=index;
        //console.log(card);
        
        return (
            <Card
              key={card.idModulo}
              description={card.descModulo}
              index={index}
              id={card.idModulo}
              text={card.text}
              titulo={card.tituloModulo}
              moveCard={moveCard}
              activo={card.activo}
              onAcordionModulo={onAcordionModulo}
              onShowModal={onShowModal}
              onEliminarModulo={onEliminarModulo}    

            />
        )
    }, [])
    return (
            
      <>

            <div style={style}>{cards.map((card, i) => renderCard(card, i, onAcordionModulo,onShowModal, onEliminarModulo ))}</div>
      </>
    )
  
}

export default Container;